<template>
  <div style="height: 100%">
    <fdc-panel
      :title="'Client-Side Pagination'"
      style="height: 100%;"
    >
      <brique-grid
        style="width: 100%; height: 70%;"
        id="paginationClient"
        :brique-grid-columns="columnDefs"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"

        :pagination="true"
        :brique-grid-is-view-pagination="true"
        :brique-grid-pagination-type="'client'"
        :pagination-page-size="100"

        :brique-grid-is-view-cud-count="false"
        :brique-grid-is-view-selected-count="false"
      />
      <!-- @grid-ready="onGridReady" -->
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import API from '@/views/Fdc/Apis/'
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'PaginationClient',
  components: {
    'monaco-editor': MonacoEditor
  },
  mounted () {
    this.getEqpEventHistoryList()
  },
  methods: {
    // async onGridReady (params) {
    //   this.gridApi = params.api
    //   this.gridColumnApi = params.columnApi

    //   await this.refreshData()
    // },
    // async refreshData () {
    //   const updateData = (data) => {
    //     this.rowData = data
    //     this.gridApi.setRowData(data)
    //   }

    //   await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
    //     .then((resp) => resp.json())
    //     .then((data) => updateData(data))
    // },
    async getEqpEventHistoryList () {
      let params = {}
      let fab = []
      let eqpId = []
      let moduleId = []

      fab.push('BRIQUE')
      eqpId.push('REFLEX01')
      moduleId.push('PM01')
      fab.push('BRIQUE')
      eqpId.push('TEL01')
      moduleId.push('PM01')

      params = {
        fab: fab + '',
        eqpId: eqpId + '',
        moduleId: moduleId + '',
        fromDate: '20220310040000000',
        toDate: '20220722235959999',
        page: 0,
        size: 100000
      }
      let data = await API.Monitor.getEqpsEvents(params)

      if (data.content.length > 0) {
        this.rowData = data.content
      } else {
        this.rowData = []
      }
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', minWidth: 70, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', flex: 1, type: 'dateTimeColumn', minWidth: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', flex: 1, type: 'dateTimeColumn', minWidth: 160 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), field: 'eventType', centered: true, flex: 1, minWidth: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', minWidth: 150, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', numeric: true, minWidth: 50, flex: 1, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.BATCH_ID'), field: 'batchId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OPER_ID'), field: 'operId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', minWidth: 100, flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', minWidth: 100, flex: 1 }
      ],
      // columnDefs: [
      //   { field: 'athlete', minWidth: 150 },
      //   { field: 'age', maxWidth: 90 },
      //   { field: 'country', minWidth: 150 },
      //   { field: 'year', maxWidth: 90 },
      //   { field: 'date', minWidth: 150 },
      //   { field: 'sport', minWidth: 150 },
      //   { field: 'gold' },
      //   { field: 'silver' },
      //   { field: 'bronze' },
      //   { field: 'total' }
      // ],

      defaultColDef: {
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid Component props 설정',
        ' */',
        '// Component props 설정',
        '` :pagination="true" `',
        '` :brique-grid-is-view-pagination="true" `',
        '` :brique-grid-pagination-type="\'client\'" ` // Pagination Type 지정',
        '` :pagination-page-size=\"100\" ` // Page Size 지정'
      ].join('\n')
    }
  }
}
</script>
